import axios from 'axios';

const URL = process.env.REACT_APP_LOCAL_API_URL;

export const getAllLanguages = async () => {
    return await axios
        .get(`${URL}/languages`)
        .then(function (res) {
            return res;
        })
        .catch(function (err) {
            console.log(err);
        });
};
